import { render, staticRenderFns } from "./CheckedItems.vue?vue&type=template&id=3c1b315e&scoped=true"
import script from "./CheckedItems.vue?vue&type=script&lang=js"
export * from "./CheckedItems.vue?vue&type=script&lang=js"
import style0 from "./CheckedItems.vue?vue&type=style&index=0&id=3c1b315e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b315e",
  null
  
)

export default component.exports